<template>
  <div class="rfp-rr-ratings-write-review-235-or body-row">
    <div class="rfp-rr-ratings-write-review-236-or body-row-left">
      <label :for="id" class="rfp-rr-ratings-write-review-237-or" v-text="label"></label>
    </div>
    <div class="rfp-rr-ratings-write-review-238-or body-row-right">
      <div class="rfp-rr-ratings-write-review-239-or">
        <select
          :id="id"
          v-model="value"
          class="rfp-rr-ratings-write-review-240-or"
          :name="id"
          @change="hndChange"
        >
          <option value="" v-text="defaultOption"></option>
          <option v-for="x in options" :key="x" :value="x" v-text="x"></option>
        </select>
        <p
          v-if="validationError"
          class="Refapp-ratings-validation-error"
          v-text="validationErrorMessage"
        ></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'rfp-ratings-write-optional-select',
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    defaultOption: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      default: () => [],
    },
    validationError: {
      type: [String, null],
      default: null,
    },
    validationErrorMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      value: '',
    };
  },
  methods: {
    // we opted to use manual event emission as v-model is broken between vue 2 and 3
    hndChange(event) {
      this.value = event.target.value;
      this.$emit('update', this.value);
    },
  },
};
</script>
